<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-21 20:06:23
-->
<template>
  <van-tabbar id="footer" v-model="activeValue" @change="navChange">
    <van-tabbar-item icon="shop">中介超市</van-tabbar-item>
    <!-- <van-tabbar-item icon="setting">机构入驻</van-tabbar-item> -->
    <van-tabbar-item icon="bill">我的订单</van-tabbar-item>
  </van-tabbar>
</template>
<script>
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { Toast } from 'vant'
export default {
  props: ['active'],
  data() {
    return {
      activeValue: this.active,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    navChange(e) {
      if (e === 1 || e === 2) {
        const isAuth = this.$store.state.market.hasAuth || false
        if (!isAuth) {
          this.activeValue = 0
          Toast('企业法人或经办人可查看')
          return
        }
      }
      if (e === 1) {
        this.buriedPoint()
      }
      this.$emit('update:active', e)
    }
  }
}
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  box-shadow: 0 0 6px #eee;
  position: fixed;
  bottom: -1px;
  z-index: 100;
  background: #fff;
}
</style>
